import {Button, Card, message} from "antd";
import './index.scss';
import {connect} from "react-redux";

import BreadcrumbComponent from "../../../../components/shared/breadcrumb/Breadcrumb";
import {useCallback, useEffect, useState} from "react";
import CostOptionFormItem from "../../../../components/settings/components/cost-option-form-input";
import SettingsTab from "../../../../components/settings/components/settings-tabs";
import {
    createNewCostOptionsAction,
    getCostOptionsAction,
    resetCostOptionsInputsValues,
    updateCostOptionsFormStateValues,
    updateCostOptionsStateValues
} from "../../../../store/actions/cost-options.action";
import {costOptionInitialState} from "../../../../store/reducers/cost-options.reducer";

const CostOptionsTabPaneComponent = ({ getCostOptionsAction, createNewCostOptionsAction,resetCostOptionsInputsValues, updateCostOptionsStateValues, updateCostOptionsFormStateValues, isEditing, loading, success, error, updates, deletes}) => {
    const handleEdit = useCallback(() => {
        updateCostOptionsStateValues({
            isEditing: true,
        })
        setActionButtons([{
            label: 'Cancel',
            type: 'secondary',
            onClick: handleCancel,
        }, {
            label: 'Save',
            type: 'primary',
            onClick: handleSave,
        }])
        // eslint-disable-next-line
    }, [updateCostOptionsStateValues])

    const handleCancel = useCallback(() => {
        resetCostOptionsInputsValues();
        setActionButtons([{
            label: 'Edit',
            type: 'primary',
            onClick: handleEdit,
        }])
        // eslint-disable-next-line
    }, [resetCostOptionsInputsValues])

    const handleSave = useCallback(() => {
        createNewCostOptionsAction();
    }, [createNewCostOptionsAction])

    const [actionButtons, setActionButtons] = useState([{
        label: 'Edit',
        type: 'primary',
        onClick: handleEdit,
    }]);

    useEffect(() => {
        if (!loading) {
            if (success) {
                message.success(success).then(() => {
                    updateCostOptionsStateValues({
                        success: '',
                    });
                    setActionButtons([{
                        label: 'Edit',
                        type: 'primary',
                        onClick: handleEdit,
                    }])
                })
            } else if (error) {
                message.error(error).then(() => {
                    updateCostOptionsStateValues({
                        error: '',
                    });
                    setActionButtons([{
                        label: 'Cancel',
                        type: 'secondary',
                        onClick: handleCancel,
                    }, {
                        label: 'Save',
                        type: 'primary',
                        onClick: handleSave,
                    }])
                })
            }

        }
    }, [loading, success, error, handleCancel, handleEdit, handleSave, createNewCostOptionsAction, updateCostOptionsStateValues])

    useEffect(() => {
        // Fetch the list of lead time options
        getCostOptionsAction()
        // eslint-disable-next-line
    }, []);

    const handleAddOption = () => {
        updateCostOptionsFormStateValues({
            del: deletes,
            update: [
                ...updates,
                {...costOptionInitialState, idx: updates.length,},
            ]
        });
    }

    return (
        <div>
            <BreadcrumbComponent actionButtons={actionButtons} />
            <Card size="small">
                <SettingsTab />
                <div className='vendor-detail-info-tab-pane-component'>
                    <div className='vendor-detail-section'>
                        <div className='cost-option-info'>
                            <div className='cost-option-info-label detail-label'>
                                <div className='detail-label-content'>
                                    <div className="label">Cost options</div>
                                    {
                                        isEditing && (
                                            <Button type='outline' onClick={handleAddOption}>+ Add option</Button>
                                        )
                                    }
                                </div>
                                <div className="divider"></div>
                            </div>
                            {
                                updates ? updates.map((value) => (
                                    <div className='cost-option-info-form'>
                                        <CostOptionFormItem idx={value.idx}/>
                                    </div>
                                )) : null
                            }
                        </div>
                    </div>
                </div>
            </Card>
        </div>
    )
}

const mapStateToProps = ({ costOptionsState }) => {
    return {
        loading: costOptionsState.loading,
        isEditing: costOptionsState.isEditing,
        success: costOptionsState.success,
        error: costOptionsState.error,
        updates: costOptionsState.costOptionsInputs.update,
        deletes: costOptionsState.costOptionsInputs.del,
    }
}

export default connect(mapStateToProps, {
    updateCostOptionsStateValues,
    updateCostOptionsFormStateValues,
    resetCostOptionsInputsValues,
    getCostOptionsAction,
    createNewCostOptionsAction,
})(CostOptionsTabPaneComponent);
